<template>
  <b-card
    no-body
    class="card-developer-meetup card w-100"
  >
    <div class="bg-light-primary rounded-top text-center">
      <b-img
        :src="require('@/assets/images/illustration/email.svg')"
        alt="Meeting Pic"
        height="170"
      />
    </div>
    <b-card-body>
      <!-- metting header -->
      <div class="meetup-header d-flex align-items-center">
        <div class="meetup-day">
          <h6 class="mb-0">
            {{ assembleia.dataHoraInicio | monthOnly }}
          </h6>
          <h3 class="mb-0">
            {{ assembleia.dataHoraInicio | dayOnly }}
          </h3>
        </div>
        <div class="my-auto">
          <b-card-title class="mb-25">
            <b-link @click="$emit('assembleiaClick', assembleia.id)">
              {{ assembleia.titulo }}
            </b-link>
          </b-card-title>
        </div>
      </div>
      <b-media no-body>
        <b-media-aside class="mr-1">
          <b-avatar
            rounded
            variant="light-primary"
            size="34"
          >
            <feather-icon
              icon="CalendarIcon"
              size="18"
            />
          </b-avatar>
        </b-media-aside>
        <b-media-body>
          <h6 class="mb-0">
            Começa {{ assembleia.dataHoraInicio | formatDatetime }}
          </h6>
          <small>Termina {{ assembleia.dataHoraEncerramento | formatDate }}</small>
        </b-media-body>
      </b-media>
      <b-media no-body>
        <b-media-aside class="mr-1">
          <b-avatar
            rounded
            variant="light-primary"
            size="34"
          >
            <feather-icon
              icon="UserIcon"
              size="18"
            />
          </b-avatar>
        </b-media-aside>
        <b-media-body>
          <h6 class="mb-0">
            {{ assembleia.presidenteId }}
          </h6>
          <small>Presidente</small>
        </b-media-body>
      </b-media>
      <b-media no-body>
        <b-media-aside class="mr-1">
          <b-avatar
            rounded
            variant="light-primary"
            size="34"
          >
            <feather-icon
              icon="CheckIcon"
              size="18"
            />
          </b-avatar>
        </b-media-aside>
        <b-media-body>
          <h6 class="mb-0">
            {{ assembleia.situacao }}
          </h6>
        </b-media-body>
      </b-media>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BMedia, BMediaBody, BMediaAside, BAvatar,
} from 'bootstrap-vue'

export default {
  components: {
    BMedia,
    BMediaBody,
    BMediaAside,
    BAvatar,
  },
  props: {
    assembleia: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {}
  },
  created() {},
}
</script>
